/* Include Utils */
/**
 * MARQUEE 3000 MARQUEE 3000 MARQUEE 3000 MARQUEE 3000 MARQUEE 3000
 * http://github.com/ezekielaquino/marquee3000
 * Marquees for the new millenium v1.0
 * MIT License
 */

;(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    define([], factory);
  } else if (typeof exports === 'object') {
    module.exports = factory();
  } else {
    root.Marquee3k = factory();
  }
}(this, function() {
  'use strict';

  class Marquee3k {
    constructor(element, options) {
      this.element = element;
      this.selector = options.selector;
      this.speed = element.dataset.speed || 0.25;
      this.pausable = element.dataset.pausable;
      this.reverse = element.dataset.reverse;
      this.paused = false;
      this.parent = element.parentElement;
      this.parentProps = this.parent.getBoundingClientRect();
      this.content = element.children[0];
      this.innerContent = this.content.innerHTML;
      this.wrapStyles = '';
      this.offset = 0;

      this._setupWrapper();
      this._setupContent();
      this._setupEvents();

      this.wrapper.appendChild(this.content);
      this.element.appendChild(this.wrapper);
    }

    _setupWrapper() {
      this.wrapper = document.createElement('div');
      this.wrapper.classList.add('marquee3k__wrapper');
      this.wrapper.style.whiteSpace = 'nowrap';
    }

    _setupContent() {
      this.content.classList.add(`${this.selector}__copy`);
      this.content.style.display = 'inline-block';
      this.contentWidth = this.content.offsetWidth;

      this.requiredReps = this.contentWidth > this.parentProps.width ? 2 : Math.ceil((this.parentProps.width - this.contentWidth) / this.contentWidth) + 1;

      for (let i = 0; i < this.requiredReps; i++) {
        this._createClone();
      }

      if (this.reverse) {
        this.offset = this.contentWidth * -1;
      }

      this.element.classList.add('is-init');
    }

    _setupEvents() {
      this.element.addEventListener('mouseenter', () => {
        if (this.pausable) this.paused = true;
      });

      this.element.addEventListener('mouseleave', () => {
        if (this.pausable) this.paused = false;
      });
    }

    _createClone() {
      const clone = this.content.cloneNode(true);
      clone.style.display = 'inline-block';
      clone.classList.add(`${this.selector}__copy`);
      this.wrapper.appendChild(clone);
    }

    animate() {
      if (!this.paused) {
        const isScrolled = this.reverse ? this.offset < 0 : this.offset > this.contentWidth * -1;
        const direction = this.reverse ? -1 : 1;
        const reset = this.reverse ? this.contentWidth * -1 : 0;

        if (isScrolled) this.offset -= this.speed * direction;
        else this.offset = reset;

        this.wrapper.style.whiteSpace = 'nowrap';
        this.wrapper.style.transform = `translate(${this.offset}px, 0) translateZ(0)`;
      }
    }

    _refresh() {
      this.contentWidth = this.content.offsetWidth;
    }

    repopulate(difference, isLarger) {
      this.contentWidth = this.content.offsetWidth;

      if (isLarger) {
        const amount = Math.ceil(difference / this.contentWidth) + 1;

        for (let i = 0; i < amount; i++) {
          this._createClone();
        }
      }
    }

    static refresh(index) {
      MARQUEES[index]._refresh();
    }

    static refreshAll() {
      for (let i = 0; i < MARQUEES.length; i++) {
        MARQUEES[i]._refresh();
      }
    }

    static init(options = { selector: 'marquee3k' }) {
      window.MARQUEES = [];
      const marquees = Array.from(document.querySelectorAll(`.${options.selector}`));
      let previousWidth = window.innerWidth;
      let timer;

      for (let i = 0; i < marquees.length; i++) {
        const marquee = marquees[i];
        const instance = new Marquee3k(marquee, options);
        MARQUEES.push(instance);
      }

      animate();

      function animate() {
        for (let i = 0; i < MARQUEES.length; i++) {
          MARQUEES[i].animate();
        }
        window.requestAnimationFrame(animate);
      }

      window.addEventListener('resize', () => {
        clearTimeout(timer);

        timer = setTimeout(() => {
          const isLarger = previousWidth < window.innerWidth;
          const difference = window.innerWidth - previousWidth;

          for (let i = 0; i < MARQUEES.length; i++) {
            MARQUEES[i].repopulate(difference, isLarger);
          }

          previousWidth = this.innerWidth;
        });
      }, 250);
    }
  }

  return Marquee3k;

}));
// Product
var warning = (function ($, window, document, root, undefined) {

const errorTime = 3000;

function errorColor(product) {
    $(".variant__select--color[data-product='" + product +"']").addClass("error");
    setTimeout(function(){
        $(".variant__select--color[data-product='" + product +"']").removeClass("error");
    }, errorTime);
    $(".warning").addClass("show");
    setTimeout(function(){ $(".warning").removeClass("show"); }, errorTime);
}

function errorSize(product) {
    $(".variant__select--size[data-product='" + product +"']").addClass("error");
    setTimeout(function(){
        $(".variant__select--size[data-product='" + product +"']").removeClass("error");
    }, errorTime);
    $(".warning").addClass("show");
    setTimeout(function(){ $(".warning").removeClass("show"); }, errorTime);
}

function errorBoth(product) {
    $(".variant__select--size[data-product='" + product +"']").addClass("error");
    $(".variant__select--color[data-product='" + product +"']").addClass("error");
    setTimeout(function(){
        $(".variant__select--size[data-product='" + product +"']").removeClass("error");
        $(".variant__select--color[data-product='" + product +"']").removeClass("error");
    }, errorTime);
    $(".warning").addClass("show");
    setTimeout(function(){ $(".warning").removeClass("show"); }, errorTime);
}

function errorTerms(product) {
    $(".warning__inner .marquee3k__wrapper p").html("Plese check the terms and conditions");
    $(".warning").addClass("show");
    setTimeout(function(){ 
        $(".warning").removeClass("show"); 
        $(".warning__inner .marquee3k__wrapper p").html("Please select a size and color.");
    }, errorTime);
}

function init() {

}


return {
    init: init,
    errorColor: errorColor,
    errorSize: errorSize,
    errorBoth: errorBoth, 
    errorTerms: errorTerms
}

})(jQuery, window, document, this);

/* Navigation */

// Header
var Header = (function ($, window, document, root, undefined) {

const body = document.getElementsByTagName("BODY")[0]
const header = document.getElementById('header')


// HEADER Slide
function headerShow() {
    header.classList.add('show')
}
function headerHide() {
  if (!header) {
    return;
  }
  
  header.classList.remove('show')
}



function init() {

}

return {
    init: init,
    headerShow: headerShow,
    headerHide: headerHide,
}

})(jQuery, window, document, this);




// Index
var Index = (function ($, window, document, root, undefined) {

const body = document.getElementsByTagName("BODY")[0];
const header = document.getElementById('header')

const indexBtnOpen = document.getElementById('index__btn--open')
const indexBtnClose = document.getElementById('index__btn--close')
const indexContent = document.getElementById('index__content')


function indexOpen() {
    indexContent.classList.add('open')
}
function indexClose() {
    indexContent.classList.remove('open')
}

function onIndexClick(e) {
    e.preventDefault();
    if (indexContent.classList.contains('open')) {
        indexClose()
    } else {
        indexOpen() 
    }
}

function addIndexHandler() {
    indexBtnOpen.addEventListener('click', onIndexClick)
    indexBtnClose.addEventListener('click', onIndexClick)
}

function bindIndexClick() {
    $(".index__grid__item").click(function() {
        var id = $(this).data("id");
        $('html, body').animate({
            scrollTop:$("#"+id).offset().top
        },'slow');
        $('.index__content').removeClass('open');
    });    
}

function init() {
    addIndexHandler()
    bindIndexClick();
}

return {
    init: init,
}

})(jQuery, window, document, this);
// Cart
var Cart = (function ($, window, document, root, undefined) {

const body = document.getElementsByTagName("BODY")[0];
const header = document.getElementById('header')

const bagBtnOpen = document.getElementById('bag__btn--open')
const bagBtnClose = document.getElementById('bag__btn--close')
const bagContent = document.getElementById('cart__content')

// BAG CLICK
function cartOpen() {
    bagContent.classList.add('open')
    body.classList.add('noscroll')
}
function cartClose() {
    bagContent.classList.remove('open')
    body.classList.remove('noscroll')
}

function onCartClick(e) {
    e.preventDefault();
    if (bagContent.classList.contains('open')) {
        cartClose()
    } else {
        cartOpen() 
    }
}

function addBagClick() {
    bagBtnOpen.addEventListener('click', onCartClick)
    bagBtnClose.addEventListener('click', onCartClick)
}



function init() {
    addBagClick()
    console.log('BagCLick added')
}

return {
    init: init,
    cartOpen: cartOpen
}

})(jQuery, window, document, this);





// Page
var Pages = (function ($, window, document, root, undefined) {

const shopUrl = $("body").data("shopurl")
const getUrl = shopUrl + "/pages/imprint"
const loader = $("#loader")
const body = document.getElementsByTagName("BODY")[0];
const logo = $("#logo__btn")

function bindClickCloseOverlay() {
    $("#page__close").on("click", function() {
        $("#overlay__page").removeClass("show")
        $(body).removeClass("noscroll")
    });
}

function fetchData(getUrl) {
    $.ajax({
        url: getUrl,
        type:'GET',
        success: function(data){
            $("#overlay__page").addClass("show");
            var content = $(data).find(".section__textpage__content")[0];
            $(".overlay__page__content").html(content);
            $(loader).hide()
            setTimeout(function(){ 
                $(body).addClass("noscroll")
            }, 300);
        }
    });
}

function bindClick() {
    $("a.pagelink").on("click", function(e) {
        e.preventDefault()
        $(loader).show()
        var page = $(this).data("page")
        var getUrl = shopUrl+"/pages/"+page
        fetchData(getUrl)
    });
}

function bindLogoClick() {
    logo.on("click", function(e) {
        e.preventDefault()
        $(loader).show()
        setTimeout(function(){ $(loader).hide(); }, 600)
    });
}

function init() {
    bindClick()
    bindClickCloseOverlay()
    bindLogoClick()
}

return {
    init: init,
}

})(jQuery, window, document, this);

// Header
var FrontpageNav = (function ($, window, document, root, undefined) {

function init() {
    Header.init()
    Index.init()
    Cart.init()
    Pages.init()
}

return {
    init: init
}

})(jQuery, window, document, this);




/* Products */
// Product

// Store
var ProductsStore = (function ($, window, document, root, undefined) {

function initStore() {
    $(".twda__product").each(function() {
        var productID = $(this).data("id");
        var productVariants = [];

        $(this).find(".twda__product__variant").each(function() {
            var id = $(this).data("id");
            var opt1 = $(this).data("opt1");
            var opt2 = $(this).data("opt2");
            var avail = $(this).data("avail");
            var variant = {
                id: id,
                opt1: opt1,
                opt2: opt2,
                avail: avail
            }
            productVariants.push(variant);
        });

        var product = {
            id: productID,
            variants: productVariants
        }

        twda.products.push(product);
    });
    // console.log(twda);
}


function init() {
    initStore();
}



return {
    init: init,
}

})(jQuery, window, document, this);



var Products = (function ($, window, document, root, undefined) {


function initStore() {
    ProductsStore.init();
}


function checkSoldOut(productID) {
    // console.log(product);
    let size = $(".product__content__add__button[data-product='" + productID +"']").data("size");
    let color = $(".product__content__add__button[data-product='" + productID +"']").data("color");
    if (size == "" || color == "") {return;}
    else {
        let variantID = getProductID(productID, size, color);
        let avail;
        twda.products.forEach(function(entry) {
            if( entry.id == productID ) {
                entry.variants.forEach(function(variant) {
                    if ( variant.id == variantID ) {
                        if( variant.avail == true) {
                            avail = true;
                            enableCartButton(productID);
                        } else {
                            avail = false;
                            diableCartButton(productID);
                        }
                    }
                });
            }
        });
    }
}


function getProductID(product,size,color) {
    
    // console.log(product+"Size "+size+"Color "+color);
    var productID = product;
    var variantID;

    twda.products.forEach(function(entry) {
        // console.log(entry.id);
        if( entry.id != productID ) {return }
        else {
            entry.variants.forEach(function(variant) {
                if( variant.opt1 == size && variant.opt2 == color) {
                    // console.log(variant.id);
                    variantID = variant.id;
                }
            });
        }
    });

    return variantID;
}

function clickSelect() {
    $(".selector--size").click(function() {
        var productID = $(this).data("product"); 
        var val = $(this).data("value");
        var sectionColor = $(this).data("color");
        $(".selector--size[data-product='" + productID +"']").removeClass("checked").css("color","white");
        $(this).addClass("checked").css("color",sectionColor);
        $(".product__content__add__button[data-product='" + productID +"']").data("size",val);
        checkSoldOut(productID);
    });
    $(".selector--color").click(function() {
        var productID = $(this).data("product"); 
        var val = $(this).data("value");
        var sectionColor = $(this).data("color");
        $(".selector--color[data-product='" + productID +"']").removeClass("checked").css("color","white");
        $(this).addClass("checked").css("color",sectionColor);
        $(".product__content__add__button[data-product='" + productID +"']").data("color",val);
        checkSoldOut(productID);
    });
}


function addProduct() {

    $(".product-button-wrapper, .product__content__add__button").click(function(e) {
      	e.preventDefault();

      	var button = this;
      	if (this.tagName === 'A') {
          button = this.firstElementChild;
      	}
      
        if ($(button).hasClass("disabled")) { return; }

        var product = $(button).data("product");
        var size = $(button).data("size");
        var color = $(button).data("color");

        // console.log("Product is"+product+" Size:  "+size+" Color: "+color);

        if ( size=="" && color=="" ) { 
            warning.errorBoth(product);
            // console.log("Everything is missing");
        } 
        else if (size=="") { 
            warning.errorSize(product);
            // console.log("Size is missing"); 
        }
        else if (color=="") { 
            warning.errorColor(product);
            // console.log("Color is missing"); 
        }
        else {
            //getProductID(product,size,color);
            CartJS.addItem(getProductID(product,size,color));
        }

        // console.log("Size: "+size+" and Color: "+color);
    });

}


function enableCartButton(productID) {
    $(".product__content__add__button[data-product='" + productID +"']").html("Add to Cart").removeClass('disabled');
}

function diableCartButton(productID) {
    $(".product__content__add__button[data-product='" + productID +"']").html("Sold Out").addClass('disabled');
}

function init() {
    initStore();
    clickSelect();
    addProduct();
}

return {
    init: init,
}

})(jQuery, window, document, this);
// Product
var product = (function ($, window, document, root, undefined) {



function initProducts() {
    $(".twda__product").each(function() {
        var productID = $(this).data("id");
        var productVariants = [];

        $(this).find(".twda__product__variant").each(function() {
            var id = $(this).data("id");
            var opt1 = $(this).data("opt1");
            var opt2 = $(this).data("opt2");
            var variant = {
                id: id,
                opt1: opt1,
                opt2: opt2
            }
            productVariants.push(variant);
        });

        var product = {
            id: productID,
            variants: productVariants
        }

        twda.products.push(product);
        // console.log(twda);
    });
}


function checkProductAvail() {
    
}

function getProductID(product,size,color) {
    
    // console.log(product+"Size "+size+"Color "+color);
    var productID = product;
    var variantID;

    twda.products.forEach(function(entry) {
        // console.log(entry.id);
        if( entry.id != productID ) {return }
        else {
            entry.variants.forEach(function(variant) {
                if( variant.opt1 == size && variant.opt2 == color) {
                    // console.log(variant.id);
                    variantID = variant.id;
                }
            });
        }
    });

    return variantID;
}


function addProduct() {

    $(".product__content__add__button").click(function() {
        var product = $(this).data("product");
        var size = $(this).data("size");
        var color = $(this).data("color");

        // console.log("Product is"+product+" Size:  "+size+" Color: "+color);

        if ( size=="" && color=="" ) { 
            warning.errorBoth(product);
            // console.log("Everything is missing");
        } 
        else if (size=="") { 
            warning.errorSize(product);
            // console.log("Size is missing"); 
        }
        else if (color=="") { 
            warning.errorColor(product);
            // console.log("Color is missing"); 
        }
        else {
            //getProductID(product,size,color);
            CartJS.addItem(getProductID(product,size,color));
        }

        // console.log("Size: "+size+" and Color: "+color);
    });

}


function clickSelect() {
    $(".selector--size").click(function() {
        var productID = $(this).data("product"); 
        var val = $(this).data("value");
        var sectionColor = $(this).data("color");

        $("article#"+productID+".selector--size").removeClass("checked").css("color","white");
        // $(".selector--size").removeClass("checked");
        // $(".selector--size").css("color","white");
        $(this).addClass("checked");
        $(this).css("color",sectionColor);
        // console.log("Size Added"+val+"");
        // $(this).closest('.select').data("value",val);
        $(".product__content__add__button[data-product='" + productID +"']").data("size",val);
    });
    $(".selector--color").click(function() {
        var productID = $(this).data("product"); 
        var val = $(this).data("value");
        var sectionColor = $(this).data("color");

        $("article#"+productID+".selector--color").removeClass("checked").css("color","white");
        // $(".selector--color").css("color","white");
        $(this).addClass("checked");
        $(this).css("color",sectionColor);

        $(".product__content__add__button[data-product='" + productID +"']").data("color",val);
        // console.log("Color Added"+val);
    });
}



function init() {
    initProducts();
    clickSelect();
    addProduct();
}

// init();

return {
    init: init,
}

})(jQuery, window, document, this);

/* Slider */

// Slider
const Sliders = (function ($, window, document, root, undefined) {


let sliders = document.getElementsByClassName('product__visual__slideshow');
len = sliders.length,
counter = 0;

function initSlider(id) {
  var slider = '#slider--'+id;
  var sliderPeg = '#slideshow__peg--'+id;

  var mySwiper = new Swiper(slider, {
      speed: 300,
      // autoplay: true,
      loop: true,
      navigation: {
        nextEl: '.slideshow__nav__next',
        prevEl: '.slideshow__nav__prev',
      },
      pagination: {
        el: sliderPeg,
        clickable: true,
      },
      effect: 'flip',
      // fadeEffect: {
      //   crossFade: true
      // },
  });
}


function initSliders() {
    [].forEach.call( sliders, function( slider ) {
        initSlider(slider.dataset.id)
    });    
}


function init() {
    initSliders()
}

return {
    init: init,
}

})(jQuery, window, document, this);

// Zoom
var Zoom = (function ($, window, document, root, undefined) {

const wrapper = $("#zoom__wrapper");
const test = "//cdn.shopify.com/s/files/1/0021/2382/5264/products/twda01_mtn_v3_orange_62a4284a-ed76-4e2b-ac7a-229703054d23_1280x.png?v=1537547642";



$('.slideshow__nav__zoom').on('click', function() {
    // console.log("click zoom");
    var imgSrcset = $(this).closest('.product__visual').find(".swiper-slide-active img").data("srcset");
    $('#zoom__wrapper').addClass('show');

    var img = buildImage(imgSrcset);
    $('#zoom__wrapper').html(img);
    // console.log(imgSrcset);
    $('#zoom__wrapper').on('click', function() {
        $(this).removeClass('show')
    });
    activateMouseMov();
});



function buildImage(imgSrcset) {

    return '<img id="zoom__img" src="" \
            data-sizes="auto" \
            data-src="" \
            data-srcset="'+imgSrcset+'" \
            alt="" \
            title="" \
            class="lazyload" />'; 
}

function activateMouseMov() { 

    var zoomWrapper = document.getElementById('zoom__wrapper');
    var zoomImg = document.getElementById('zoom__img');

    document.addEventListener('mousemove', function(e){
    // var x = e.clientX / window.innerWidth;
    // var y = e.clientY / window.innerHeight;

    var windowHalfX = window.innerWidth/2;
    var windowHalfY = window.innerHeight/2;

    var mouseX = (e.clientX - windowHalfX)/windowHalfX;
    var mouseY = (e.clientY - windowHalfY)/windowHalfY;

    var x = -mouseX*50;
    var y = -mouseY*50;
    zoomImg.style.transform = 'translate(' + x + 'vw,' + y + 'vh) scale(1.4)';
      // zoomImg.style.webkitTransform = 'translateX(' + x + '%)';
    })
}


function init() {

}

return {
    init: init,
}

})(jQuery, window, document, this);

// Slider
const Slider = (function ($, window, document, root, undefined) {

function init() {
  Sliders.init()
  Zoom.init()
}

return {
    init: init,
}

})(jQuery, window, document, this);

/* Include Shader */
// Shader 


function superTest() {
  console.log('Super Test');
}

function hexToHSL(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    r = parseInt(result[1], 16);
    g = parseInt(result[2], 16);
    b = parseInt(result[3], 16);
    r /= 255, g /= 255, b /= 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s, l = (max + min) / 2;
    if(max == min){
      h = s = 0; // achromatic
    }else{
      var d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch(max){
        case r: h = (g - b) / d + (g < b ? 6 : 0); break;
        case g: h = (b - r) / d + 2; break;
        case b: h = (r - g) / d + 4; break;
      }
      h /= 6;
    }
  var HSL = new Object();
  HSL['h']=h;
  HSL['s']=s;
  HSL['l']=l;
  return HSL;
}
/**
 * Author: 
 *
 * Adapted and put together from:
 * Warp shader – http://www.iquilezles.org/www/articles/warp/warp.htm
 * Mouse input – https://www.shadertoy.com/view/4sd3WB
 **/


const VERTEX_SHADER = `
    varying vec2 vUv;
    uniform float iTime;
    
    void main() {
        vUv = uv;
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position,1.0);
    }
`;

const BUFFER_A_FRAG = `
    uniform vec4 iMouse;
    uniform sampler2D iChannel0;
    uniform vec2 iResolution;
    uniform float iTime;
    uniform float iFrame;
    varying vec2 vUv;
    
    #define mousedata(a,b) texture2D( iChannel0, (0.5+vec2(a,b)) / iResolution.xy, -0.0 )
    #define backbuffer(uv) texture2D( iChannel0, uv ).xy
    
    void main() {
        vec2 r = gl_FragCoord.xy - iMouse.xy;
        float d = 0.0001*dot(r,r);
        if(iMouse.z > 0.0 && d < 0.01) {
        gl_FragColor = vec4(0.0,0.2,0,0);
        return;
        }

        gl_FragColor = texture2D(iChannel0, vUv);
    }
`;

const BUFFER_B_FRAG = `
    uniform vec4 iMouse;
    uniform sampler2D iChannel0;
    uniform vec3 iResolution;    
    
    void main() {
        float dx = 1.0/iResolution.x;
        float dy = 1.0/iResolution.y;
        vec2 uv = gl_FragCoord.xy / iResolution.xy;

        vec2 udu = texture2D(iChannel0, uv).xy;
        float u = udu.x;
        float du = udu.y;

        float ux = texture2D(iChannel0, vec2(uv.x+dx, uv.y)).x;
        float umx = texture2D(iChannel0, vec2(uv.x-dx, uv.y)).x;
        float uy = texture2D(iChannel0, vec2(uv.x, uv.y+dy)).x;
        float umy = texture2D(iChannel0, vec2(uv.x, uv.y-dy)).x;

        float nu = u + du + 0.5*(umx+ux+umy+uy-4.0*u);
        nu = 0.99*nu;
        gl_FragColor = vec4(nu,nu-u,0.0,100.0);
    }
`;

const BUFFER_FINAL_FRAG = `
    uniform sampler2D iChannel0;
    uniform float iTime;
    varying vec2 vUv;
    uniform vec3 colorHsv;
    uniform float valueOne;
    uniform float valueTwo;

    float ltime;

    float noise(vec2 p) {
        return sin(p.x * 3.5) * sin(p.y * (2.5 + sin(ltime / 18.))) + .1 * valueTwo; 
    }

    mat2 rotate(float angle){
        return mat2(cos(angle), -sin(angle), sin(angle), cos(angle));
    }

    float fbm(vec2 p) {
        p *= 1.1;
        float f = 0.;
        float amp = .5;
        for( int i = 0; i < 3; i++) {
            mat2 modify = rotate(ltime/50. * float(i*i));
            f += amp*noise(p);
            p = modify * p;
            p *= 2.;
            amp /= 2.2;
        }
        return f;
    }

    float pattern(vec2 p, out vec2 q, out vec2 r) {
        q = vec2( fbm(p + vec2(1.)),
            fbm(rotate(.1*ltime)*p + vec2(3.)));
        r = vec2( fbm(rotate(.2)*q + vec2(0.)),
            fbm(q + vec2(0.)));
        
        return fbm(p* + .3 * r * valueOne);
    }

    vec3 hsv2rgb(vec3 c) {
        vec4 K = vec4(1.0, 2.0 / 3.0, 1.0 / 3.0, 3.0);
        vec3 p = abs(fract(c.xxx + K.xyz) * 6.0 - K.www);
        return c.z * mix(K.xxx, clamp(p - K.xxx, 0.0, 1.0), c.y);
    }

    void main() {
        ltime = iTime;

        float ctime = iTime + fbm(vUv / 8.0) * 40.0 + texture2D(iChannel0, vUv).x;
        float ftime = fract(ctime/6.);
        ltime = floor(ctime/6.) + (1.-cos(ftime*3.1415)/2.);
        ltime = ltime*6.;
        vec2 q;
        vec2 r;
        float f = pattern(vUv, q, r);
        
        
        vec3 col = hsv2rgb(vec3(colorHsv.x, (abs(r.y) * 2.3) * colorHsv.y, (r.x * f * 3. + 0.8) * colorHsv.z)); 
        
        gl_FragColor = vec4(col, 1.0);
    }
`;

// return fbm(p + 1.*r);
// float ctime = iTime + fbm(vUv / 8.0) * 40.0 + texture2D(iChannel0, vUv).x;
// vec3 col = hsv2rgb(vec3(0.075, abs(r.y) * 1.5, r.x * f + 1.05));
    // float noise(vec2 p) {
    //     return sin(p.x*4.5) * sin(p.y*(3. + sin(ltime/11.))) + .20; 
    // }


class BufferShader {
    constructor(fragmentShader, uniforms) {
        this.material = THREE.ShaderMaterial;
        this.scene = THREE.Scene;
        this.uniforms = uniforms;
        this.material = new THREE.ShaderMaterial({
            fragmentShader,
            vertexShader: VERTEX_SHADER,
            uniforms: this.uniforms
        });
        this.scene = new THREE.Scene();
        this.scene.add(
            new THREE.Mesh(new THREE.PlaneBufferGeometry(2, 2), this.material)
        );
    }
}

class BufferManager {
    constructor(renderer, { width, height }) {
        this.readBuffer = THREE.WebGLRenderTarget;
        this.writeBuffer = THREE.WebGLRenderTarget;
        this.renderer = renderer;

        this.readBuffer = new THREE.WebGLRenderTarget(width, height, {
            minFilter: THREE.LinearFilter,
            magFilter: THREE.LinearFilter,
            format: THREE.RGBAFormat,
            type: THREE.FloatType,
            stencilBuffer: false
        });

        this.writeBuffer = this.readBuffer.clone();

        this.swap = this.swap.bind(this);
        this.render = this.render.bind(this);
    }

    swap() {
        const temp = this.readBuffer;
        this.readBuffer = this.writeBuffer;
        this.writeBuffer = temp;
    }

    render(scene, camera, toScreen) {
        if (toScreen) {
            this.renderer.render(scene, camera);
        } else {
            this.renderer.render(scene, camera, this.writeBuffer, true);
        }
        this.swap();
    }
}

class ShaderClass {
    constructor() {
        this.container = document.getElementById('background');
        this.width = this.container.clientWidth;
        this.height = this.container.clientHeight;
        this.renderer = new THREE.WebGLRenderer();
        this.loader = new THREE.TextureLoader();
        this.mousePosition = new THREE.Vector4();
        this.orthoCamera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1);
        this.counter = 0;
        this.clock = new THREE.Clock();

        this.targetA = new BufferManager(this.renderer, {
            width: this.width,
            height: this.height
        });
        this.targetB = new BufferManager(this.renderer, {
            width: this.width,
            height: this.height
        });
        this.targetC = new BufferManager(this.renderer, {
            width: this.width,
            height: this.height
        });

        this.bufferA = BufferShader;
        this.bufferB = BufferShader;
        this.bufferC = BufferShader;

        this.shaderID;

        this.renderer.setSize(this.width, this.height);
        this.container.appendChild(this.renderer.domElement);

        this.mousePosition.setZ(1);

        this.renderer.domElement.addEventListener('mousedown', () => {
            this.mousePosition.setZ(1);
            this.counter = 0;
        });

        this.renderer.domElement.addEventListener('mouseup', () => {
            this.mousePosition.setZ(1);
        });

        this.renderer.domElement.addEventListener('mousemove', event => {
            this.mousePosition.setX(event.clientX);
            this.mousePosition.setY(this.height - event.clientY);
        });

        this.animate = this.animate.bind(this);
        this.start = this.start.bind(this);
    }

    animate() {
        this.shaderID = requestAnimationFrame(() => {
            const elapsed = this.clock.getElapsedTime();
            this.bufferA.uniforms['iFrame'].value = this.counter++;
            this.bufferA.uniforms[
                'iChannel0'
            ].value = this.targetB.readBuffer.texture;
            this.targetA.render(this.bufferA.scene, this.orthoCamera);

            this.bufferB.uniforms[
                'iChannel0'
            ].value = this.targetA.readBuffer.texture;
            this.targetB.render(this.bufferB.scene, this.orthoCamera);

            this.bufferImage.uniforms[
                'iChannel0'
            ].value = this.targetB.readBuffer.texture;
            this.bufferImage.uniforms['iTime'].value = elapsed;
            this.targetC.render(this.bufferImage.scene, this.orthoCamera, true);

            this.animate();
        });
    }

    stop() {
        cancelAnimationFrame(this.shaderID);
    }

    updateSize(newWidth,newHeight) {
        this.renderer.setSize(newWidth, newHeight);
    }

    start(cH,cS,cV,valOne,valTwo) {
        const resolution = new THREE.Vector3(
            this.width,
            this.height,
            window.devicePixelRatio
        );
        this.loader.setCrossOrigin('');

        this.bufferA = new BufferShader(BUFFER_A_FRAG, {
            iFrame: { value: 0 },
            iResolution: { value: resolution },
            iMouse: { value: this.mousePosition },
            iChannel0: { value: null },
            iTime: { value: 0.0 }
        });

        this.bufferB = new BufferShader(BUFFER_B_FRAG, {
            iFrame: { value: 0 },
            iResolution: { value: resolution },
            iMouse: { value: this.mousePosition },
            iChannel0: { value: null },
            iTime: { value: 0.0 }
        });

        this.bufferImage = new BufferShader(BUFFER_FINAL_FRAG, {
            iResolution: { value: resolution },
            iMouse: { value: this.mousePosition },
            iChannel0: { value: null },
            iTime: { value: 0.0 },
            // colorHsv: { value: [0.24, 0.28, 1.0] }
            colorHsv: { value: [cH, cS, 1.0] },
            valueOne: { value: valOne },
            valueTwo: { value: valTwo }
        });

        this.animate();
    }
}













var Shader = (function ($, window, document, root, undefined) {

let shader;
let threshold = 0;

function initShaderClass() {
    shader = new ShaderClass()
}

function initShaderFunction() {

    let shaderActive = false;
    let placeholders = document.getElementsByClassName('product__placeholder');
    let options = {
      threshold: threshold
    }
    let observer = new IntersectionObserver( (entry, observer) => {    
    // console.log('entry:', entry);
    //console.log('observer:', observer);

        if (shaderActive == false && entry[0].isIntersecting == true) {
            // console.log("Activate Shader");
            // console.log(entry[0].target.getAttribute('data-color'));   
            let sectionColor = entry[0].target.getAttribute('data-color');
            let sectionValOne = entry[0].target.getAttribute('data-valone');
            let sectionValTwo = entry[0].target.getAttribute('data-valtwo');
            var HSL = hexToHSL(sectionColor);
            shader.start(HSL.h,HSL.s,HSL.l,sectionValOne,sectionValTwo);
            shaderActive = true;
        } else if (shaderActive == true && entry[0].isIntersecting == false) {
            // console.log("DEE Activate Shader");
            shader.stop();
            shaderActive = false;
        }

    }, options);

    for (let i = 0; i < placeholders.length; ++i) {
        var placeholder = placeholders[i];  
        observer.observe(placeholder);
        // console.log(item.getAttribute('data-color'));
    }
}

function initResize() {
    window.onresize = function(event) {
        const container = document.getElementById('background');
        let width = container.clientWidth;
        let height = container.clientHeight;
        shader.updateSize(width,height);
    };
}

function init() {
    initShaderClass()
    initShaderFunction()
    initResize()
}

return {
    init: init,
}

})(jQuery, window, document, this);





// Viewport
var viewport = (function ($, window, document, root, undefined) {

var scrollY;
var firstProductOffset;

function windowScroll() {
    window.addEventListener('scroll', function() {
        scrollY = window.scrollY;
        if ( scrollY >= firstProductOffset ) {
            Header.headerShow()
        } else {
            Header.headerHide()
        }
    });    
}

function setFirstProductOffset() {
    var products = document.getElementsByClassName("product__ticker");
    var firstProduct = products[0];
    firstProductOffset = firstProduct.offsetTop;
}

function onResize() {
    window.onresize = function(event) {
        setFirstProductOffset();
    };   
}


function init() {
    windowScroll();
    setFirstProductOffset();
    onResize();
}

init();

return {
    init: init,
    onResize: onResize,
    setFirstProductOffset: setFirstProductOffset
}



})(jQuery, window, document, this);
// Intro
var intro = (function ($, window, document, root, undefined) {

const intro = document.getElementById('intro');
const body = document.getElementsByTagName("BODY")[0];


function checkLoaded() {

    body.classList.add('noscroll');
    var imgs = document.getElementsByClassName('lazypreload');
    len = imgs.length,
    counter = 0;

    [].forEach.call( imgs, function( img ) {
        // console.log(img)
        img.addEventListener( 'load', incrementCounter, false );
    } );

    function incrementCounter() {
        counter++;
        if ( counter === len ) {
            // console.log( 'All images loaded!' );
            introOut();
            body.classList.remove('noscroll');
        }
    }

}

function introOut() {
    setTimeout(function(){  
    intro.classList.add('loaded');
    $("#intro").animate({height: "75vh"}, 600, function() {
        //viewport.setFirstProductOffset();
        // console.log("Animation complete!")
    });
    }, 50);
}

function init() {
    checkLoaded();
    // introOut();
    //intro.classList.add('loaded')
}

init();

return {
    init: init,
}

})(jQuery, window, document, this);
(function () {
    var _overlay = document.getElementById('cart__content');
    var _clientY = null; // remember Y position on touch start

    _overlay.addEventListener('touchstart', function (event) {
        if (event.targetTouches.length === 1) {
            // detect single touch
            _clientY = event.targetTouches[0].clientY;
        }
    }, false);

    _overlay.addEventListener('touchmove', function (event) {
        if (event.targetTouches.length === 1) {
            // detect single touch
            disableRubberBand(event);
        }
    }, false);

    function disableRubberBand(event) {
        var clientY = event.targetTouches[0].clientY - _clientY;

        if (_overlay.scrollTop === 0 && clientY > 0) {
            // element is at the top of its scroll
            event.preventDefault();
        }

        if (isOverlayTotallyScrolled() && clientY < 0) {
            //element is at the top of its scroll
            event.preventDefault();
        }
    }

    function isOverlayTotallyScrolled() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
        return _overlay.scrollHeight - _overlay.scrollTop <= _overlay.clientHeight;
    }
}())
// Checkout
var Checkout = (function ($, window, document, root, undefined) {

function init() {
    $("#checkout").on('click', function(e) {
        if ($('#agree').is(':checked')) {
            $(this).submit();
        } else {
            e.preventDefault();
            warning.errorTerms();
        }
    });
}

return {
    init: init,
}

})(jQuery, window, document, this);

document.addEventListener('DOMContentLoaded', () => {

    const body = document.getElementsByTagName("BODY")[0];

    if ( body.classList.contains('template-index') ) {
        FrontpageNav.init();
        Marquee3k.init()
        Shader.init()
        Sliders.init()
        Products.init()
        Checkout.init()
    }

    if ( body.classList.contains('template-cart') ) {
        FrontpageNav.init();
        Marquee3k.init()
        Shader.init()
        Sliders.init()
        Products.init()
        Checkout.init() 

        Cart.cartOpen()
    }
    if ( body.classList.contains('template-page') ) {
        body.classList.remove('noscroll');
    }
});







